import { MinervaReferenceData } from './models/minerva-reference-data.model';
import { ReferenceData } from './models/reference-data.model';
import { GenericReferenceData } from './models/generic-reference-data';

export class LoadReferenceDataItemPayload<T extends GenericReferenceData> {
  constructor(
    public url: string,
    public type: string,
    // tslint:disable-next-line:no-any variable-name typedef
    public generic: (new (any) => T),
    public date?: string
  ) {

  }
}
